import { Environment, EnvironmentName } from 'src/app/core/models/environment.models';

export const environment: Environment = {
  name: EnvironmentName.DEV,
  apiUrl: 'https://dev-goomi.wlcmapps.com/mobile/api',
  stripeKey:
    'pk_test_51KsmLRHK4CLt7Dv1dI1SgA2O4vkFIldlSOjUd1pGr7sfyRb7AjPdZAn7HUp2PWJaDifLIQkue3BIyzgiyg9i2a5A00I4Rcf9UZ',
  branchKey: 'key_test_bCpPVDGbOJvGQOpkz7cQqbflqxoDozex',
  sentryDsn: 'https://289e4a6212a348616a25aef5b46c3a9a@o4510041164349440.ingest.us.sentry.io/4510041165725696',
};
